import { render, staticRenderFns } from "./printLogisticsSettlement.vue?vue&type=template&id=4a5edd6e&scoped=true&"
import script from "./printLogisticsSettlement.vue?vue&type=script&lang=js&"
export * from "./printLogisticsSettlement.vue?vue&type=script&lang=js&"
import style0 from "./printLogisticsSettlement.vue?vue&type=style&index=0&id=4a5edd6e&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5edd6e",
  null
  
)

component.options.__file = "printLogisticsSettlement.vue"
export default component.exports